import React, { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useHistory } from "react-router";
import { requestCanceller } from "../../../service/axiosCancelToken";
import { getDailyViews } from "../../../service/viewerService";
import LoadingBar from "../../shared/LoadingBar";
import LoadingSpinner from "../../shared/LoadingSpinner";
import CollapseView from "./CollapseViews";
// import '../scrollbar.css'
import './Daily.css';

const Daily = () => {
    const [params, setParams] = useState({currentPage: 1});
    const [items, setItems] = useState();
    const [allItemsCount, setAllItemsCount] = useState();
    const [hasMore, setHasMore] = useState(true);
    const itemsRef = useRef(null);
    const history = useHistory();

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllViews = async () => {
            try {
                let { status, data } = await getDailyViews(params,{cancelToken: cancelRequest.signal});
                if (status === 201) {

                    if(itemsRef.current){
                        itemsRef.current = itemsRef.current.concat(data.currentDocs);
                        setItems(itemsRef.current);
                    }
                    else{
                        itemsRef.current = data.currentDocs;
                        setItems(itemsRef.current)
                        setAllItemsCount(data.allDocsCount)
                    }
                }
            } catch (err) {
                if (err.response && err.response.status === 401) {
                    history.replace('/user/login');
                }
            }
        }
        fetchAllViews();
        return () => {
			cancelRequest.cancel();
        }
    }, [history, params]);

    useEffect(() => {
        if(items && allItemsCount && (items.length >= allItemsCount)){
            setHasMore(false);
        }
    },[items, allItemsCount])

    const fetchMoreData = () => {
        let nextPage = params.currentPage + 1;
        setParams({currentPage: nextPage})
    };
    return (
        <React.Fragment>
            <div className=" text-light mt-4">
                <div
                    className="infinite-scroll-daily"
                    id="scrollableDiv"
                >
                    {
                        (items && items.length > 0) ?
                            <InfiniteScroll
                                dataLength={items.length}
                                next={fetchMoreData}
                                hasMore={hasMore}
                                loader={
                                    <div className="d-flex">
                                        <span className="mx-auto">
                                            <LoadingBar
                                                type="spinningBubbles"
                                                color="#0eac1b"
                                            />
                                        </span>
                                    </div>
                                }
                                endMessage={
                                    <p style={{ textAlign: "center" }}>
                                        <b>The End</b>
                                    </p>
                                }
                                scrollableTarget="scrollableDiv">
                                {items.map(item => (
                                    <CollapseView
                                        key={item._id}
                                        date={item._id}
                                        viewers={item.viewers}
                                    />
                                ))}
                            </InfiniteScroll> :
                            <div style={{ height: '55vh' }} className="d-flex">
                                <div className="text-center align-self-center mx-auto">
                                    <LoadingSpinner />
                                </div>
                            </div>
                    }
                </div>
            </div>
        </React.Fragment>
    );
};

export default Daily;
